import MesspunktDto from './MesspunktDto'

export default class VerbrauchsstaetteDto {

  constructor(json) {
    if (json) {
      this.json = json

      this.id = json.id
      this.name = json.name
      this.strasse = json.strasse
      this.zusatz = json.zusatz
      this.plz = json.plz
      this.ort = json.ort
      this.kanton = json.kanton
      this.netzzugangsberechtigung = json.netzzugangsberechtigung
      this.messpunkten = json.messpunkten.map(mp => new MesspunktDto(mp))
    } else {
      this.json = {}
      this.messpunkten = []
    }
  }

  get adresse() {
    return [
      [this.plz, this.ort].filter(v => v).join(' '),
      [this.strasse, this.zusatz].filter(v => v).join(' ')
    ].filter(v => v).join(', ')
  }

  get ausnahmegruppe() {
    return `verbrauchsstaette.ausnahmegruppe.${this.json.ausnahmegruppe.toLowerCase()}`
  }
}
